import React from "react";
import { Link, useNavigate } from "react-router-dom";

const AdminNavbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    alert("Logged out successfully!");
    navigate("/login");
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark shadow">
      <div className="container-fluid">
        <a className="navbar-brand ">
          <img
            src="https://timehouse.store/logo-white.svg"
            alt="Logo"
            height="40"
            className="d-inline-block align-top me-2"
          />
        </a>
        <div className="d-flex">
          {/* Using Link instead of button */}
          <Link className="btn text-light me-2 text-decoration-none" to="/admin/dashboard">
            Users
          </Link>
          <Link className="btn text-light me-2 text-decoration-none" to="/admin/store">
            Stores
          </Link>
          <button className="btn btn-outline-light" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar;